/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { Button, FormControl, Overlay, Tooltip, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import axios from 'axios';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { changepassword } from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
// import toast from 'shared/toast';

import { ToasterMessage } from 'shared/toast/toast';

// style imports
import './ChangePassword.scss';

/**
 * 
 * this page is used to change user's password
 * 
 * @param props
 * 
 * @return html code for change password
 * 
**/

export class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: { value: '', showPassword: false, error: false },
            passwordStrength: { status: '', upper: false, numeric: false, count: false, lower:false, special:false },
            confirmPassword: { value: '', showPassword: false, error: '' },
            valid: false,
            windowWidth: window.innerWidth,
            loading:false,
            changePasswordStatus: { show: false, type: '', message: ''}
        };
        this.passwordForm = createRef();
        this.approveBack = false
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.props.history.push({ pathname: '/Home' });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ ...this.state, windowWidth: window.innerWidth });
    };

    /* toggles when clicking password eye icon */
    useShowPassword = (name) => {
        this.setState(() => ({
            [name]: { ...this.state[name], showPassword: !this.state[name].showPassword }
        }));
    }

    /* check validation for input changes */
    handlePasswordInput = (name, passwordValue) => {
        passwordValue = Validators.checkPassword(passwordValue, this.state[name].value);
        this.setState({
            ...this.state,
            [name]: { ...this.state[name], value: passwordValue, error: passwordValue.length>=8?false:true }
        },()=>{    
            if (name === "password") {
                this.checkPasswordStrength(passwordValue);
            }
            else
                this.checkPassword(passwordValue);
        });        
    }

    /* validation of password strength */
    checkPasswordStrength = (enteredPassword) => {
        const upperRegExp = new RegExp("^(?=.*[A-Z])");
        const numericRegExp = new RegExp("^(?=.*[0-9])");
        const lengthRegExp = new RegExp("^(?=.{8,15})");
        const lowerRegExp = new RegExp("^(?=.*[a-z])");
        const specialRegExp = new RegExp("^(?=.*[!@#$%^&*])");
        var strength = 0;
        let upperCheck = false;
        let numericCheck = false;
        let countCheck = false;
        let lowerCheck = false;
        let specialCheck = false;

        /* check for uppercase character in password */
        if (upperRegExp.test(enteredPassword)) {
            strength += 1;
            upperCheck = true;
        }
        /* check for lowercase character in password */
        if (lowerRegExp.test(enteredPassword)) {
            strength += 1;
            lowerCheck = true;
        }
        /* check for special character in password */
        if (specialRegExp.test(enteredPassword)) {
            strength += 1;
            specialCheck = true;
        }
        /* check for number in password */
        if (numericRegExp.test(enteredPassword)) {
            strength += 1;
            numericCheck = true;
        }
        /* check for Minimum 8- Maximum 15 characters */
        if (lengthRegExp.test(enteredPassword) && enteredPassword.length < 16) {
            strength += 1;
            countCheck = true;
        }
        
        /* password strength Weak */
        if (strength < 4) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, value: enteredPassword, error: true },
                passwordStrength: { status: 'Weak', upper: upperCheck, numeric: numericCheck, count: countCheck, lower: lowerCheck, special: specialCheck }
            }, () => {
                if (this.state.confirmPassword.value) {
                    this.checkPassword(this.state.confirmPassword.value);
                }
            });
        }
        /* password strength Good */
        else if (strength === 4) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, value: enteredPassword, error: true },
                passwordStrength: { status: 'Good', upper: upperCheck, numeric: numericCheck, count: countCheck, lower: lowerCheck, special: specialCheck }
            }, () => {
                if (this.state.confirmPassword.value) {
                    this.checkPassword(this.state.confirmPassword.value);
                }
            });
        }

        /* password strength Strong */
        else if (strength === 5) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, value: enteredPassword, error: false },
                passwordStrength: { status: 'Strong', upper: upperCheck, numeric: numericCheck, count: countCheck, lower: lowerCheck, special: specialCheck }
            }, () => {
                if (this.state.confirmPassword.value) {
                    this.checkPassword(this.state.confirmPassword.value);
                }
            }
            );
        }
    }

    /* validation of confirm password */
    checkPassword = (confirmPasswordValue) => {
        let errorString = "Password does not match";
        /* password match check */
        if (this.state.password.value === confirmPasswordValue) {
            this.setState({
                ...this.state,
                confirmPassword: { ...this.state.confirmPassword, value: confirmPasswordValue, error: '' },
                valid: true
            });

        }
        else {
            this.setState({
                ...this.state,
                confirmPassword: { ...this.state.confirmPassword, value: confirmPasswordValue, error: errorString },
                valid: false
            });
        }
    }

    /* hide tooltip on input blur */
    passwordBlur = () => {
        if (this.state.password.value.length < 1) {
            this.setState({
                ...this.state,
                password: { ...this.state.password, error: false }
            });
        }
    }

    /* called when save button clicked and change the password*/
    submitPassword = () => {
        this.setState({loading:true});
        let password = { password: btoa(this.state.confirmPassword.value)};
        axios.post(getSellerUrl(changepassword),JSON.stringify({data:password}),getSellerHeaders())
        .then(response => {
            if(response.data.status === 'success'){
                this.setState({
                    loading:false,
                    changePasswordStatus: { show: true, type: 'success', message: 'Saved'}
                }, () => {
                    setTimeout( () => {
                        this.setState({
                            password: { ...this.state.password, value: ''},
                            confirmPassword: { ...this.state.confirmPassword, value: '' },
                            changePasswordStatus : { show: false, type: '', message: ''}
                        });
                    }, 3000)
                });
                // toast.success('Successful');
            }
        })
        .catch(error =>{
            this.setState({
                loading:false,
                changePasswordStatus: { show: true, type: 'danger', message: error.response.data['message']}
            });
            // toast.error(error.response.data['message']);
        });
    }

    render() {
        const { password, passwordStrength, confirmPassword, valid } = this.state
        let status = passwordStrength.status;
        /* css class based on password strength */
        let progressBarClass = 'progress-bar';
        let progressStrengthClass = ''
        if (status === 'Weak') {
            progressBarClass = "progress-bar progress-bar-danger progress-bar-weak-width";
            progressStrengthClass = "text-danger";
        }
        else if (status === 'Good') {
            progressBarClass = "progress-bar progress-bar-success progress-bar-good-width";
            progressStrengthClass = "text-success good";
        }
        else if (status === 'Strong') {
            progressBarClass = "progress-bar progress-bar-success progress-bar-strong-width";
            progressStrengthClass = "text-success strong";
        }

        return (
            <div className="d-flex flex-column" style={{overflow:"auto"}}>
                <div className="d-flex flex-row align-items-center border-bottom border-outline" style={{ minHeight: '40px' }}>
                    <div className="d-flex flex-row align-items-center justify-content-center border-right border-outline px-2 h-100">
                        <Link to="/home">
                            <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                            <span className="ml-2">Back</span>
                        </Link>
                    </div>
                    <span className="text-secondary mx-2">Change Password</span>
                </div>
                <div className="change-password">
                    {/* { this.state.loading ? 
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="default" height="100px" width="100px" />
                        </div> :  */}
                        <Form className="change-password-card">
                            <div>
                                <div className="float-control" ref={this.passwordForm}>
                                    {
                                        password.showPassword ?
                                            <i className="password-icon fas fa-eye fa-flip-horizontal" onClick={() => this.useShowPassword('password')} /> :
                                            <i className="password-icon fas fa-eye-slash fa-flip-horizontal" onClick={() => this.useShowPassword('password')} />
                                    }
                                    <Form.Control type={password.showPassword ? 'text' : 'password'} id="password" name="password" value={ this.state.password.value } placeholder=" " className={ this.state.password.value ? 'form-control-active' : ''} onBlur={this.passwordBlur} onChange={(event) => this.handlePasswordInput(event.target.name, event.target.value)} />
                                    <label htmlFor="password" >New Password</label>
                                </div>
                                <Overlay transition={false} container={this.passwordForm.current} id="overlay" placement={this.state.windowWidth > 760 ? "right" : "bottom"} show={(passwordStrength.upper && passwordStrength.numeric && passwordStrength.count) || (password.error === false) ? false : true}>
                                    <Tooltip className="overlay-tooltip">
                                        <div>
                                            <p style={{ marginBottom: "4px" }}>Password Strength:&nbsp;&nbsp;<span className={progressStrengthClass}>{passwordStrength.status}</span></p>
                                            <div className="progress">
                                                <div id="password-strength" className={progressBarClass} role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                            <ul className="list-unstyled">
                                                <li className=""><span className={passwordStrength.lower ? "lower-case text-success" : ""}><i className={passwordStrength.lower ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Lowercase (a-z)</li>
                                                <li className=""><span className={passwordStrength.upper ? "upper-case text-success" : ""}><i className={passwordStrength.upper ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Uppercase (A-Z)</li>
                                                <li className=""><span className={passwordStrength.numeric ? "one-number text-success" : ""}><i className={passwordStrength.numeric ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span> &nbsp;Atleast 1 Number (0-9)</li>
                                                <li className=""><span className={passwordStrength.count ? "eight-character text-success" : ""}><i className={passwordStrength.count ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Between 8 to 15 Characters</li>
                                                <li className=""><span className={passwordStrength.special ? "special-char text-success" : ""}><i className={passwordStrength.special ? "fa fa-check" : "fa fa-times"} aria-hidden="true"></i></span>&nbsp;Atleast 1 Symbol Character</li>
                                                <li className="">Allowed Symbol Characters (!, @, #, $, %, ^, &, *)</li>
                                            </ul>
                                        </div>
                                    </Tooltip>
                                </Overlay>
                            </div>
                            <div>
                                <div className="float-control">
                                    {
                                        confirmPassword.showPassword ?
                                            <i className="password-icon fas fa-eye fa-flip-horizontal" onClick={() => this.useShowPassword('confirmPassword')} /> :
                                            <i className="password-icon fas fa-eye-slash fa-flip-horizontal" onClick={() => this.useShowPassword('confirmPassword')} />
                                    }
                                    <FormControl type={confirmPassword.showPassword ? 'text' : 'password'} id="confirmPassword" name="confirmPassword" value= { this.state.confirmPassword.value } placeholder=" " className={ this.state.confirmPassword.value ? 'form-control-active' : ''} onChange={(event) => this.handlePasswordInput(event.target.name, event.target.value)} />
                                    <label htmlFor="confirmPassword">Retype Password</label>
                                    <div className="text" style={{ margin: "0px 0px", top: "auto", right: "auto", textAlign: "start" }}>
                                        {
                                            !valid && confirmPassword.error.length > 1 ?
                                                <small className="error">{confirmPassword.error}</small> : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: "6%" }} >
                                <div id="toaster" className= { this.state.changePasswordStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster ": ''}>
                                    {
                                    this.state.changePasswordStatus.show ?
                                        <ToasterMessage type={this.state.changePasswordStatus.type} message={this.state.changePasswordStatus.message} className="alert-handle"></ToasterMessage>
                                        : null
                                    }
                                </div>
                                <div className="d-flex flex-row justify-content-center mt-4">
                                    <Button type="button" variant="outline-primary" style={{ width: '100px' }} className=" btn-white mx-1" onClick={() => this.props.history.push('/home')}>Cancel</Button>
                                    <Button type="button" variant="secondary" className="mx-1" style={{ width: '100px', cursor: valid ? '' : 'not-allowed' }} disabled={valid && this.state.passwordStrength.status==='Strong' && !this.state.loading && this.state.changePasswordStatus.type !== 'success' ? false : true} onClick={this.submitPassword}>Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                </div>    
                            </div>
                        </Form>
                    {/* }     */}
                </div>
            </div>
        );
    }
}